import { useState, useEffect, Fragment } from 'react'
import classname from 'classnames'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Portal from '@/components/Portal'
import { ReactComponent as IconSuccess } from '@/assets/svgs/icon-status-success.svg'
import { ReactComponent as IconError } from '@/assets/svgs/icon-status-error.svg'

const Toast = ({ toastList, autoDelete=true, dismissTime=5000 }) => {

	const [list, setList] = useState(toastList)

	useEffect(()=> {
		setList([...toastList])
	}, [toastList])

	useEffect(() => {
		const interval = setInterval(()=> {
			if (autoDelete && toastList.length && list.length){
				deleteToast(toastList[0].id)
			}
		}, dismissTime)

		return () => {
			clearInterval(interval);
		}

	}, [toastList, autoDelete, dismissTime, list]);

	function deleteToast(id) {
		const listItemIndex = list.findIndex(e => e.id === id)
		const toastListItemIndex = toastList.findIndex(e => e.id === id)
		list.splice(listItemIndex, 1);
		toastList.splice(toastListItemIndex, 1)

		setList([...list])
	}

	return (
		<Portal id="toast">
			{
				list.map((toast, index) => {
					const toastClass = classname({
						'toast': true,
						'toast--success': toast.type === "success",
						'toast--error': toast.type === "error"
					})

					return (
						typeof(toast.message) != "undefined" ?
							<div className={toastClass} key={index}>
								<div className='toast__content'>
									<span className="toast__content__left">
										{toast.type=== "success" && <IconSuccess />}
										{toast.type=== "error" && <IconError />}
									</span>
									<span className="toast__content__middle">
										{toast.message}
									</span>
									<span className="toast__content__right">
										<div className="toast__close link" onClick={()=>deleteToast(toast.id)}>
											<IconClose />
										</div>
									</span>
								</div>

							</div>
						: null
					)
				})
			}
		</Portal>
	)
}

export default Toast
